import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Warning } from '../../../helpers/icon-dictionary';
import SvgIcon from '../../svg-icon/svg-icon';
import Button from '../../button/index';
import css from '../index.scss';
import { DARK } from '../../button/variants';
import messages from '../messages';

const TaskCarryForwardConfirmation = (props) => {
    const { intl, commonTasks, handleOnBack, handleOnCarryTaskCancel, handleOnCarryTask } = props;

    return (
        <div className={css.confirmationContainer}>
            <div className={css.icon}>
                <SvgIcon icon={Warning} />
            </div>
            <div className={css.confirmTitle}>{intl.formatMessage(messages.tasksCarryForwardMessage1, { commonTasks })}</div>
            <div className={css.confirmTitle}>{intl.formatMessage(messages.tasksCarryForwardMessage2)}</div>
            <div className={css.confirmBtnContainer}>
                <div className={css.spacing}><Button
                    handleOnClick={handleOnBack}
                    label={intl.formatMessage(messages.back)}
                    variant={DARK} /></div>
                <div className={css.spacing}><Button
                    handleOnClick={handleOnCarryTaskCancel}
                    label={intl.formatMessage(messages.no)}
                    variant={DARK} /></div>
                <Button
                    handleOnClick={handleOnCarryTask}
                    label={intl.formatMessage(messages.yes)}
                    variant={DARK} />
            </div>
        </div>
    );
};

TaskCarryForwardConfirmation.propTypes = {
    intl: intlShape.isRequired,
    commonTasks: PropTypes.number,
    handleOnBack: PropTypes.func,
    handleOnCarryTaskCancel: PropTypes.func,
    handleOnCarryTask: PropTypes.func
};

export default injectIntl(styleable(css)(TaskCarryForwardConfirmation));



// WEBPACK FOOTER //
// ./app/components/assign-course-mapper-admin/task-carry-forward/task-carry-forward.js